import React from 'react';
import historyProt from '../../images/home/History_of_Protestantism_vol_2-s.jpg';
import journey from '../../images/home/JOURNEY-THROUGH-NIGHT-4.jpg';
import { Link } from 'react-router-dom';

import './who-we-are.scss';

/**
 * WhoWeAre Component.
 * Introduces the user to the company. It tells in a quick way about the company
 * and provides the link redirecting to the About Us page
 */
function WhoWeAre() {
   return (
      <main className="container-fluid wwa-main">
         <div className="row justify-content-center wwa-heading">
            <h2>Who We Are</h2>
         </div>

         <div className="row justify-content-center align-items-center">
            <div className="wwa-content d-flex">
               <div className="d-flex justify-content-center order-0">
                  <div className="wwa-content-img">
                     <Link to="products/20242"><img src={historyProt} alt="History of Protestantism"></img></Link>
                  </div>
               </div>
               
               <div className="p-4 order-1"></div>
               <div className="wwa-content-text d-flex align-items-center order-2">
                  <h1>Inheritance Publications is a small company which was established to provide Biblical Reformed literature. <Link to="/about-us">Read more...</Link></h1>
               </div>
            </div>
         </div>
         

         <div className="row justify-content-center align-items-center">
            <div className="wwa-content d-flex">
               <div className="d-flex justify-content-center order-0 order-sm-2">
                  <div className="wwa-content-img">
                     <Link to="products/08295"><img src={journey} alt="Journey Through the Night"></img></Link>
                  </div>
               </div>
               <div className="p-4 order-1"></div>
               <div className="wwa-content-text d-flex align-items-center order-2 order-sm-0">
                  <h1>Church Music & Records is a small company specialized in Choral and Organ Recordings and Sheet Music on Psalms and Hymns for Choir and Organ. <Link to="/about-us">Read more...</Link></h1>
               </div>
            </div>
         </div>
      </main>
   )
}

export default WhoWeAre;